import {initViewComponentsExamples} from "../../development/view-components/examples";
import {initGridsExamples} from "../../development/grids/examples";
import {initCreateTestVoeOrder} from "../../development/voe-orders.createTestOrder";

function registerDevelopmentComponents(components) {
	/**
	 * Development
	 */

	components['development.view-components.examples'] = {
		action: initViewComponentsExamples,
	};

	components['development.grids.examples'] = {
		action: initGridsExamples,
	};

	/**
	 * Custom Components
	 */

	components['development.voe-orders.create-test-order'] = {
		action: initCreateTestVoeOrder,
	}
}

export {registerDevelopmentComponents}
